class CategoryTabsSection extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('.category-tab'));
    this.panels = Array.from(this.querySelectorAll('.category-panel'));

    if (this.tabs.length === 0 || this.panels.length === 0) return;

    // Unique storage key per section so multiple category sections stay independent
    this.storageKey = 'catTabs:' + (this.dataset.testid || this.id || 'default');

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', (event) => {
        event.preventDefault();
        this.activate(tab);
      });
      tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
    });

    // Restore the last selected category on load (survives page refresh)
    this.restoreSelection();
  }

  restoreSelection() {
    let saved = null;
    try {
      saved = sessionStorage.getItem(this.storageKey);
    } catch (e) {
      saved = null;
    }
    if (!saved) return;

    const savedTab = this.tabs.find((tab) => tab.getAttribute('data-target') === saved);
    // Only switch if it exists and isn't already the active one
    if (savedTab && !savedTab.classList.contains('is-active')) {
      this.activate(savedTab, { scroll: false, persist: false });
    }
  }

  activate(targetTab, options = {}) {
    const { scroll = true, persist = true } = options;
    const targetId = targetTab.getAttribute('data-target');
    if (!targetId) return;

    this.tabs.forEach((tab) => {
      const isActive = tab === targetTab;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    this.panels.forEach((panel) => {
      const isMatch = panel.id === targetId;
      panel.hidden = !isMatch;
    });

    if (persist) {
      try {
        sessionStorage.setItem(this.storageKey, targetId);
      } catch (e) {
        /* storage unavailable — ignore */
      }
    }

    if (scroll && targetTab.scrollIntoView) {
      targetTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }

  onKeydown(event, currentIndex) {
    const lastIndex = this.tabs.length - 1;
    let nextIndex = null;

    switch (event.key) {
      case 'ArrowRight':
        nextIndex = currentIndex === lastIndex ? 0 : currentIndex + 1;
        break;
      case 'ArrowLeft':
        nextIndex = currentIndex === 0 ? lastIndex : currentIndex - 1;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = lastIndex;
        break;
      default:
        return;
    }

    if (nextIndex !== null) {
      event.preventDefault();
      const nextTab = this.tabs[nextIndex];
      nextTab.focus();
      this.activate(nextTab);
    }
  }
}

if (!customElements.get('category-tabs-section')) {
  customElements.define('category-tabs-section', CategoryTabsSection);
}
